// opTable.context.ts
import type { InjectionKey } from 'vue';

export type SortDir = '' | 'asc' | 'desc';

export interface ColumnMeta {
    key?: string;          // chiave di filtro (es. 'name')
    sortKey?: string;      // chiave di sort (es. 'name')
    filterType?: 'text' | 'checkbox' | 'date' | 'number' | 'dateRange' | 'numberRange' | 'select';
    fromKey?: string;      // per i range
    toKey?: string;
}

export interface OpTableContext {
    // filtri
    getFilterValue: (key: string) => any;
    setFilterValue: (key: string, value: any, meta?: ColumnMeta) => void;
    
    // sort (chiave unica attiva)
    getSort: () => { key?: string; dir: SortDir };
    setSort: (key?: string, dir?: SortDir) => void;
}

export const OP_TABLE_CTX: InjectionKey<OpTableContext> = Symbol('OP_TABLE_CTX');
